// Columnas del head por defecto
export const defaultFields = () => {
    return [
        {
            key: 'material_name',
            label: 'Nombre del material',
            sortable: true
        },
        {
            key: 'nu',
            label: 'Código UN',
            sortable: true
        },
        {
            key: 'gre',
            label: 'Gre',
            sortable: true
        },
        {
            key: 'actions',
            label: 'Acciones'
        }
    ];
}

// Columnas del head por defecto de la tabla de detalles del NU - GRE
export const defaultFieldsDetails = () => {
    return [
        {
            key: 'custom_field',
            label: 'Campo personalizado',
            sortable: true
        },
        {
            key: 'description',
            label: 'Descripción',
            sortable: true
        },
        {
            key: 'is_active',
            label: 'Estado',
            sortable: true
        },
        {
            key: 'actions',
            label: 'Acciones'
        }
    ];
}

// Configuración de la tabla head
export const dataConfigTable = () => {
    return {
        fields: defaultFields(),
        fieldsDetails: defaultFieldsDetails(),
        dataFields: {
            page: 1,
            total: 0,
            current_page: 1,
            per_page: 10
        },
        dataFieldsDetails: {
            page: 1,
            total: 0,
            current_page: 1,
            per_page: 10
        }
    }
}

// 
export const defaultDetailsNuGres = () => {
    return {
        id: null,
        description: "",
        is_active: true,
        slq_emergency_response_guide_id: null,
        slq_custom_field_nu_gre_id: null
    }
}

export default {

    // Globales
    useSelectNuGreInFrom: false,

    // Index 
    tableConfig: dataConfigTable(),
    responseGuidesOfEmergencies: [],

    // Formulario
    action: 'CREATE',
    emergencyResponseGuides: [],
    customFields: [],
    currentDetailsNuGre: defaultDetailsNuGres(),

    // Listado de detalles de las emergencias
    currentNuGreActive: null,
    detailsOfGuide: []

}
